import styled from '@emotion/styled';

const SpaceBetweenContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export default SpaceBetweenContainer;
